import Box from '@mui/material/Box'
import Toolbar from 'app/components/toolbar/Toolbar'
import {Outlet} from 'react-router-dom'
import Navigation from './Navigation'

export default function MasterLayout() {
  return (
    <>
      <Navigation>
        <Box mt={8} display={'flex'} flex={1} flexDirection={'column'} bgcolor={'white'}>
          <Toolbar />
          <Outlet />
        </Box>
      </Navigation>
    </>
  )
}
